

































































































































import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'
import Modal from '@/components/Modal'
import { required, minLength } from 'vuelidate/lib/validators'
import './AddEditTeamRole.scss'
import { TeamRole, TEAM_ROLE_ABILITY_ACTIONS, TEAM_ROLE_SUBJECTS_UI, TeamRoleSubjects, TeamRoleActionMapping } from '@/abilitiesByRole'
import { cloneDeep } from 'lodash'

enum ModalMode {
  Edit = 'edit',
  Create = 'create',
  ReadOnly = 'read_only'
}

export default Vue.extend({
  name: 'AddEditTeamRole',
  props: {
    teamRole: {
      type: Object as () => TeamRole,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalTitle (): string {
      switch (this.mode) {
        case ModalMode.ReadOnly:
          return 'View standard Role'
        case ModalMode.Create:
          return 'Create a new Team Role'
        case ModalMode.Edit:
        default:
          return 'Edit Team Role'
      }
    },
    modalSubmitButtonText (): string {
      return this.readOnly ? 'Close' : 'Submit'
    },
    teamRoleAbilityActions (): Record<TeamRoleSubjects, TeamRoleActionMapping> {
      return TEAM_ROLE_ABILITY_ACTIONS
    },
    teamRoleSubjectsUI (): Record<TeamRoleSubjects, string> {
      return TEAM_ROLE_SUBJECTS_UI
    }
  },
  data () {
    return {
      submitStatus: '',
      mode: ModalMode.Edit,
      localTeamRole: cloneDeep(this.teamRole)
    }
  },
  validations: {
    localTeamRole: {
      name: {
        required,
        minLength: minLength(2)
      }
    }
  },
  created () {
    if (this.readOnly) {
      this.mode = ModalMode.ReadOnly
    } else {
      this.mode = this.localTeamRole.name === '' ? ModalMode.Create : ModalMode.Edit
    }
  },
  methods: {
    formSubmitted (): void {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.$emit('addEditDone', this.localTeamRole)
      }
    },
    hideModal (): void {
      this.$emit('closeModal')
    },
    updateRead (evt, teamRoleSubject: TeamRoleSubjects): void {
      if (evt.target.checked) {
        this.localTeamRole.abilities[teamRoleSubject].read = true
      }
    },
    updateWriteDelete (evt, teamRoleSubject: TeamRoleSubjects): void {
      if (!evt.target.checked) {
        this.localTeamRole.abilities[teamRoleSubject].write = false
        this.localTeamRole.abilities[teamRoleSubject].delete = false
      }
    },
    checkFakeDisable (evt: InputEvent): void {
      if (this.readOnly)
        evt.preventDefault()
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    Modal
  }
})
